import React from 'react';
import BubbleBox from '../../../pages/settings/components/BubbleBox';
import '../Style/TagsBox.css';
import {IProps} from '../Config/TagsBox.types';

const TagsBox = ({className = 'tags-grid', tags, deleteTag, onClick, id = ''}:IProps) => (
    <div id={id ? id : null} onClick={onClick} className={className}>
        {tags && tags.map((tag, index) => <BubbleBox
            classNameDiv='property-box-inner'
            key={tag.name}
            title={tag.name}
            isCorrect={!tag.isInCorrect}
            onDelete={deleteTag ? () => deleteTag(tag) : null}
            index={index}
            type=''
        />) }
    </div>
);

export default TagsBox;
